export default __webpack_public_path__ + "static/media/beaccess.eb4af377.png";